import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "border-border/60 bg-transparent text-foreground hover:bg-muted/60",
        muted: "border-transparent bg-muted text-muted-foreground",
        accent: "border-transparent bg-accent text-accent-foreground hover:bg-accent/90",
        subtle: "border-border/50 bg-background/70 text-muted-foreground",
        ghost: "border-transparent bg-transparent text-foreground",
      },
      size: {
        xs: "text-[10px] leading-[14px] px-2 py-0.5",
        sm: "text-xs leading-4 px-2.5 py-0.5",
        default: "text-xs leading-4 px-3 py-1",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({
  className,
  variant,
  size,
  ...props
}: BadgeProps): JSX.Element {
  return (
    <div className={cn(badgeVariants({ variant, size }), className)} {...props} />
  )
}
// eslint-disable-next-line react-refresh/only-export-components
export { Badge, badgeVariants }
